import React, { useState, useEffect } from 'react';
import { IDENTITY } from '../data';
import { useIsMobile } from '../hooks/useIsMobile';

const NAV_LINKS = [
  { label: 'Work', href: '#experience' },
  { label: 'Story', href: '#story' },
  { label: 'Projects', href: '#projects' },
  { label: 'Skills', href: '#skills' },
  { label: 'Writing', href: '#writing' },
  { label: 'Beliefs', href: '#beliefs' },
  { label: 'Contact', href: '#contact' },
];

export default function Nav({ path }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close overlay when switching to desktop
  useEffect(() => { if (!isMobile) setMobileOpen(false); }, [isMobile]);

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        padding: isMobile ? '0 20px' : '0 48px',
        height: '64px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: scrolled || mobileOpen ? 'rgba(250,250,248,0.96)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled && !mobileOpen ? '1px solid rgba(26,26,26,0.08)' : 'none',
        transition: 'all 0.4s ease',
      }}>
        <a href="#hero" style={{ textDecoration: 'none' }}>
          <span style={{ fontFamily: 'var(--font-display)', fontSize: '20px', fontWeight: 600, color: 'var(--ink)', letterSpacing: '-0.02em' }}>
            {IDENTITY.shortName}
          </span>
          <span style={{ fontFamily: 'var(--font-mono)', fontSize: '10px', color: 'var(--ink-light)', marginLeft: '8px', letterSpacing: '0.15em' }}>
            {path === 'work' ? '/ work' : '/ vision'}
          </span>
        </a>

        {/* Desktop links */}
        {!isMobile && (
          <div style={{ display: 'flex', gap: '32px', alignItems: 'center' }}>
            {NAV_LINKS.map(link => (
              <a key={link.label} href={link.href} style={{
                fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.12em',
                color: 'var(--ink-mid)', textDecoration: 'none', textTransform: 'uppercase',
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--ink)'}
              onMouseLeave={e => e.target.style.color = 'var(--ink-mid)'}
              >{link.label}</a>
            ))}
            <a href="#contact" style={{
              fontFamily: 'var(--font-mono)', fontSize: '10px', letterSpacing: '0.15em',
              color: 'var(--bg)', background: 'var(--ink)', padding: '8px 18px',
              textDecoration: 'none', textTransform: 'uppercase',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => e.target.style.opacity = '0.8'}
            onMouseLeave={e => e.target.style.opacity = '1'}
            >Hire Me</a>
          </div>
        )}

        {/* Hamburger button */}
        {isMobile && (
          <button
            onClick={() => setMobileOpen(o => !o)}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', gap: '5px',
              padding: '8px', zIndex: 1001,
            }}
          >
            <span style={{ display: 'block', width: '22px', height: '1.5px', background: 'var(--ink)', transition: 'all 0.3s', transform: mobileOpen ? 'translateY(6.5px) rotate(45deg)' : 'none' }} />
            <span style={{ display: 'block', width: '22px', height: '1.5px', background: 'var(--ink)', transition: 'all 0.3s', opacity: mobileOpen ? 0 : 1 }} />
            <span style={{ display: 'block', width: '22px', height: '1.5px', background: 'var(--ink)', transition: 'all 0.3s', transform: mobileOpen ? 'translateY(-6.5px) rotate(-45deg)' : 'none' }} />
          </button>
        )}
      </nav>

      {/* Mobile overlay */}
      {isMobile && mobileOpen && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 999,
          background: 'var(--bg)',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start',
          padding: '80px 20px 40px',
        }}>
          {NAV_LINKS.map((link, i) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              style={{
                fontFamily: 'var(--font-display)', fontSize: '40px', fontWeight: 600,
                color: 'var(--ink)', textDecoration: 'none', letterSpacing: '-0.02em',
                lineHeight: 1.3, display: 'block',
                opacity: 0, animation: `fadeUp 0.4s ease ${i * 0.06}s both`,
              }}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMobileOpen(false)}
            style={{
              fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.2em',
              color: 'var(--bg)', background: 'var(--ink)', padding: '14px 28px',
              textDecoration: 'none', textTransform: 'uppercase',
              marginTop: '32px', display: 'inline-block',
            }}
          >
            Hire Me
          </a>
        </div>
      )}
    </>
  );
}
